import * as constants from "../widgetConstants.js";
import u from "../../../util/index.js";
import {WIDGET, getWidgetName, getFilterText} from "../widgetConstants.js";
import {createRecord} from "../../../indexedDB/index.js";

const DashboardItem = (rec) => {
    if(rec.WIDGET_SRNO === WIDGET.FREQUENT_MEMBER.SRNO && !Mutil.isFunc('FREQUENT_MEMBER_WIDGET')) return '';
    if(rec.WIDGET_SRNO === WIDGET.WEEKLY_MY_TASK.SRNO && !Mutil.isFunc('WIDGET_WEEKLY_MY_TASK')) return '';

    const temp = {
        WIDE: rec.WIDGET_ROW === "2" ? "widget-wide-item" : "",
        SRNO: rec.WIDGET_SRNO,
        WIDGET_USER_SRNO: rec.WIDGET_USER_SRNO,
        WIDGET_ROW: rec.WIDGET_ROW,
        WIDGET_NM: rec.WIDGET_NM,
        FIL_END_DT_GUBUN: rec.FIL_END_DT_GUBUN,
        COLABO_SRNO: rec.COLABO_SRNO || 0
    }
    let targetSetting;
    let widgetKey = '';
    for (const key in WIDGET) {
        if (WIDGET[key].SRNO === temp.SRNO) {
            targetSetting = WIDGET[key].SETTING
            widgetKey = key
        }
    }
    return targetSetting ? getItem({...temp, ...targetSetting, widgetKey}) : ''
}

//위젯 설정에서 보이는 위젯 아이템
const SettingItem = (rec = 0, wide, widgetnm, isEnter = false, isAvailable = false) => {
    if (!u.isFunc('DASHBOARD_KRX')) {
        if (isEnter) return '';
    }
    if (rec === 0) return '';
    const rec_img = rec.length > 1 ? rec : '0' + rec;
    const itemClass = Number(wide) === 2 ? 'wide-item' : 'item'
    return `<li class="${itemClass} ${isAvailable ? "" : "js-add-disable"}">
                <input type="checkbox" 
                       name="${rec}" 
                       id="dashboard-widget-img-${rec_img}"
                       ${isAvailable ? "" : "disable"}>
                <label for="dashboard-widget-img-${rec_img}">
                    <span class="widget-title">${widgetnm}</span>
                    <span class="span-widget">
                        <span>${i18next.t(dictionary.add)}</span>
                    </span>
                </label>
            </li>`
}

const getItem = (props) => {
    const {
        WIDE,
        SRNO,
        COLABO_SRNO,
        WIDGET_USER_SRNO,
        WIDGET_ROW,
        WIDGET_NM,
        type = '',
        scroll = '',
        project_binding = '',
        directBtn = '',
        delBtn = true,
        sizeBtn = true,
        allReadBtn = false,
        todayBtn = false,
        tabBtn = '',
        tabArr = [],
        activeTab = 0,
        filterBtn = '',
        filter = '',
        FIL_END_DT_GUBUN = '2',
        search = '',
        hrefDirect = '',
        widgetKey = '',
        verticalList = false,
    } = props;
    return `<li class="${constants.WIDGET_SRNO[SRNO] && 'widget-' + constants.WIDGET_SRNO[SRNO]} ${filterBtn ? 'js-filter-widget' : ''} ${verticalList ? 'update-hr' : ''}" 
                data-type = "${widgetKey}"
                wide="${WIDE}" 
                id="${WIDGET_USER_SRNO}" 
                srno="${SRNO}" 
                colabo_srno="${COLABO_SRNO}"
            >
                <h3>
                   <div class="widget-title-wrap">
                       ${getProjectBinding(project_binding)}
                       ${getWidgetNM(SRNO, WIDGET_NM, COLABO_SRNO)}
                       ${getFilter(filterBtn, WIDGET_USER_SRNO, SRNO, FIL_END_DT_GUBUN, filter)}
                       ${getToday(todayBtn)}
                       ${getAllRead(allReadBtn)}
                   </div>
                   <div class="widget-button-wrap">
                       ${getDirect(directBtn, COLABO_SRNO)}
                       ${getHrefDirect(hrefDirect)}
                       <button class="widget-more-button"><i class="ico-more"></i></button>
                       <div class="js-widget-more-layer widget-button-popup d-none">
                          ${getDelete(delBtn)}
                          ${getSize(sizeBtn, WIDGET_ROW, WIDE)}
                       </div>
                   </div>
                </h3>
                ${getTab(tabBtn, FIL_END_DT_GUBUN, tabArr, activeTab)}
                ${getType(type, scroll)}
            </li>`
}

const getProjectBinding = (project_binding) => {
    if (!project_binding) return '';
    return `<button class="button-project-change"><i class="ico-arrow"></i></button>`
}

const getWidgetNM = (SRNO, WIDGET_NM, COLABO_SRNO) => {
    if (SRNO === 2 || !WIDGET_NM) return '';
    const widgetName = getWidgetName(SRNO);
    return `<span class="title js-mouseover js-over-tooltip ${+u.n2v(COLABO_SRNO, '0') !== 0 ? 'direct': ''} " mouseover-text="${widgetName}">${widgetName}</span>`
}

const getDirect = (directBtn, COLABO_SRNO) => {
    if (!directBtn) return '';
    return `<button class="direct" style="display: ${!u.isFunc('WIDGET_DIRECT') || +u.n2v(COLABO_SRNO, '0') === 0 ? 'none' : 'block'}">${i18next.t(dictionary.more)}</button>`
}

const getHrefDirect = (hrefDirect) => {
    if (!hrefDirect) return '';
    return `<button class="href-direct">${i18next.t(common.more)}</button>`
}

const getDelete = (delBtn) => {
    if (!delBtn) return '';
    return `<button class="button-del-widget">${i18next.t(common.remove, {val: $t(dictionary.widget)})}</button>`
}
const getToday = (todayBtn) => {
    if (!todayBtn) return '';
    return `<button class="js-move-today schedule-today" >${i18next.t(dictionary.today)}</button>`
}
const getAllRead = (allReadBtn) => {
    if (!allReadBtn) return '';
    return `<button class="js-alarm-read-all alarm-readall">${i18next.t(common.readAll)}</button>`
}

const getSize = (sizeBtn, WIDGET_ROW, WIDE) => {
    if (!sizeBtn) return '';
    return `<button class="widget-changing" data-widget-col=${WIDGET_ROW}>${WIDE ? i18next.t(main.halfSizeWidget) : i18next.t(main.fullSizeWidget)}</button>`
}

const getFilter = (filterBtn, WIDGET_USER_SRNO, SRNO, filterValue, filterGb = '') => {
    if (!filterBtn) return '';

    const filterConstants = constants[filterGb] || constants.end_dt_filter;
    const val = +u.n2v(filterValue, "1");
    let hoverText = '';
    if (SRNO === WIDGET.MEMBER.SRNO) {
        if (val === 1) hoverText = i18next.t(main.orderByRecentCollabo)
        if (val === 2) hoverText = i18next.t(main.orderByFrequentCollabo)
    }

    return `<button class="button-filter" filter="${filterBtn}">
                <span class="${hoverText && val !== 3 ? 'js-mouseover js-button-tooltip' : ''}" 
                      mouseover-text="${hoverText ?? ''}">
                    ${getFilterText(filterGb || 'end_dt', val-1)}
                </span>
                <i></i>
                <ul class="js-widget-filter-layer widget-filter-mini-pop d-none">
                    ${filterConstants.map((filGb, idx) => spreadFilter(WIDGET_USER_SRNO, SRNO, idx + 1, filterGb, val === idx + 1)).join('')}
                </ul>
            </button>`
}

const spreadFilter = (WIDGET_USER_SRNO, SRNO, filValue, filterGb, isChecked) => {
    return `<li>
                <input 
                    class="js-filter-input"
                    type="radio" 
                    data-fil-type="${filValue}" 
                    id="${WIDGET_USER_SRNO}_filter_${filValue}" 
                    name="${SRNO}" ${isChecked ? 'checked' : ''}
                    >
                <label for="${WIDGET_USER_SRNO}_filter_${filValue}">
                    ${getFilterText(filterGb, filValue - 1)}
                </label>
            </li>`
}

const getTab = (tabBtn, filterValue, tabArr = [], activeTab = 0) => {
    if (!tabBtn) return '';
    if (tabBtn === 'work') {
        return `<ul class="widget-tab-title">
                <li FIL_END_DT_GUBUN = '${filterValue != "1" && filterValue != "3" ? "2" : filterValue}' class="active tab_1">${i18next.t(main.task.upcoming)} <span>0</span></li>
                <li FIL_END_DT_GUBUN ='5' class="tab_2">${i18next.t(main.task.overdue)} <span>0</span></li>
            </ul>`
    }
    return `<ul class="widget-tab-title">
                ${tabArr.map((tab, idx) => spreadTab(tab, idx, activeTab)).join('')}
            </ul>`
}

const spreadTab = (tab, idx, activeTab) => {
    return `<li class="${idx === activeTab ? 'active' : ''} tab_${idx}">${tab}</li>`
}

const getType = (type, scroll) => {
    if (type === 'calendar') {
        return `<ul class="widget-schedule-wrap">
                    <li><div class="widget-calendar-wrap"></div></li>
                    <li class="${getScroll(scroll)}" >
                        <ul class="widget-schedule-list dash-pending">
                            <li class="dash-num-pending">
                                <div class="loading type2 pending">
                                    <i class="circle"></i>
                                    <i class="circle"></i>
                                    <i class="circle"></i>
                                    <i class="circle"></i>
                                    <i class="circle"></i>
                                </div>
                            </li>
                        </ul>
                    </li>
                </ul>`
    } else if (type === 'major') {
        return ` <ul class="container1">
                                    ${constants.menu_class.map((dat, idx) => `<li class="item ${dat}-count href-item">
                                            <p>${constants.menu_nm[idx]}</p>
                                            <p class="count">0</p>
                                        </li>`).join('')}
                                    </ul>`
    } else {
        return `<ul class="widget-article-list dash-pending js-widget-article-list ${type === 'chat' || type === 'star' ? 'participants-list chat-list-area chat-list star-list' : ''} ${getScroll(scroll)}" >
                    <li class="dash-num-pending">
                        <div class="loading type2 pending">
                            <i class="circle"></i>
                            <i class="circle"></i>
                            <i class="circle"></i>
                            <i class="circle"></i>
                            <i class="circle"></i>
                        </div>
                    </li>
                </ul>`
    }
}


const getScroll = (scroll) => {
    if (!scroll) return '';
    return 'scroll-mask thin'
}


/*데이터가 없을 경우에 대한 template 처리 함수*/
const getNoData = (widget) => {

    const NoData = {
        mention: `${i18next.t(main.alert.noMention)}`,
        chat: `${i18next.t(main.alert.startChat)}\n<button class="js-new-chat">${i18next.t(dictionary.add)}</button>`,
        bookmark: `${i18next.t(main.alert.noBookMarkPost)}`,
        star: `${i18next.t(main.alert.noFavoriteGroup)}`,
        project: `${i18next.t(main.alert.noPostInProject)}`,
        alarm: `${i18next.t(main.alert.allReadNoti)}`,
        deadline: `${i18next.t(main.alert.noUpcomingTask)}`,
        delay: `${i18next.t(main.alert.noOverdueTask)}`,
        task: `${i18next.t(main.alert.noTaskInProject)}`,
        schedule: `${i18next.t(main.alert.noEvent)}`,
        file: `${i18next.t(main.alert.noFileInProject)}`,
        binding: `${i18next.t(main.alert.noSelectedProject)}<button class="button-project-select">${i18next.t(dictionary.add)}</button>`,
        notGet: `새로고침이 필요합니다.`,
        notPriv: `협업공간의 참여자가 아닙니다.<br>버튼을 눌러 프로젝트를 선택하세요.<button class="button-project-select">${i18next.t(dictionary.add)}</button>`,
        notPrivFix: `협업공간의 참여자가 아닙니다.<br>담당자에게 문의해주세요.`,
        member: `${i18next.t(main.inviteCollaborator)}
                        <button class="js-member-invite button-member-invite 
                            ${_USE_INTT_ID.indexOf('UTLZ') > -1 ? 'd-none' : ''}"
                        >${i18next.t(dictionary.invite)}</button>`,
        myPrj: `${i18next.t(main.noProjectExist)}<button class="js-new-prj">${i18next.t(dictionary.add)}</button>`,
        favorite: `${i18next.t(main.noFavoriteProject)}`,
        data: `${i18next.t(common.noData)}`,
    }

    return `<li class="widget-null-wrap">
    	<p>${NoData[widget]}</p>
	</li>`;
}


/*태그가 들어간 타이틀 text로 변환하여 반환하는 함수*/
const ttl2text = (ttl) => {
    let returnTtl = ttl;
    if (ttl.indexOf('{"COMPS":') === -1 && ttl.indexOf('{"SYS_CODE":') === -1) return returnTtl;

    returnTtl = "";
    try {
        const compArr = JSON.parse(ttl).COMPS;
        returnTtl = compArr.map((v) => {
            if (v.COMP_TYPE === "TEXT") {
                return v.COMP_DETAIL.CONTENTS;
            }
        }).join('')
    } catch (e) {
        //pass
    }
    return returnTtl;
}


/*프로젝트 타이틀을 설정하고 타이틀이 없을 경우 권한이 없다 판단하여 바인딩이 해제된 것으로 표시하는 함수*/
const setProjectTtl = ($item, props) => {
    let {
        TTL = "",
        COLABO_SRNO = "",
        WIDGET_USER_SRNO = "",
    } = props;

    if (u.n2v(TTL) === "") {
        $item.find('.button-project-change').addClass('d-none');
        $item.find('.direct').addClass('d-none');
        $item.find('.widget-article-list, .js-widget-article-list').html(getNoData('binding'));
        return true;
    }
    $item.find('.title').text(TTL).attr('mouseover-text', TTL).addClass('direct');
    $item.find('.button-project-change').removeClass('d-none');
    $item.find('.direct').removeClass('d-none');
    return false;
}


// const getSearch = (search) => {
//     if(!search) return '';
//     return `<input id="searchInputAjax" type="text" autocomplete="off" placeholder="검색어를 입력해주세요">`
// }


const SettingPopupHtml = () => {
    return `
         <article class="popup-layer dashboard-set-popup">
        <header><h1>${i18next.t(common.setting, {val: $t(dictionary.widget)})}</h1>
            <button id="" class="btn-close">
            <i class="icons-close-1"></i>
            </button>
        </header>
        <div class="popup-main scroll-mask thin">
            <dl class="dashboard-color-pick-wrap">
                <dt>${i18next.t(dictionary.background)}</dt>
                <dd>
                    <ul>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-01" mode="dashboard-light"><label for="dashboard-bg-color-01" class="dashboard-bg-color-01"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-02" mode="dashboard-light"><label for="dashboard-bg-color-02" class="dashboard-bg-color-02"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-03" mode="dashboard-light"><label for="dashboard-bg-color-03" class="dashboard-bg-color-03"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-04" mode="dashboard-light"><label for="dashboard-bg-color-04" class="dashboard-bg-color-04"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-05" mode="dashboard-light"><label for="dashboard-bg-color-05" class="dashboard-bg-color-05"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-06" mode="dashboard-light"><label for="dashboard-bg-color-06" class="dashboard-bg-color-06"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-07" mode="dashboard-light"><label for="dashboard-bg-color-07" class="dashboard-bg-color-07"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-08" mode="dashboard-dark"><label for="dashboard-bg-color-08" class="dashboard-bg-color-08"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-09" mode="dashboard-dark"><label for="dashboard-bg-color-09" class="dashboard-bg-color-09"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-10" mode="dashboard-dark"><label for="dashboard-bg-color-10" class="dashboard-bg-color-10"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-11" mode="dashboard-dark"><label for="dashboard-bg-color-11" class="dashboard-bg-color-11"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-color-12" mode="dashboard-dark"><label for="dashboard-bg-color-12" class="dashboard-bg-color-12"><span></span></label>
                        </li>
                    </ul>
                </dd>
            </dl>
            <dl class="dashboard-bg-pick-wrap">
                <dt class="d-none">배경사진</dt>
                <dd>
                    <ul>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-11" mode="dashboard-dark"><label for="dashboard-bg-img-11" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-11-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-10" mode="dashboard-dark"><label for="dashboard-bg-img-10" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-10-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-23" mode="dashboard-dark"><label for="dashboard-bg-img-23" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-23-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-44" mode="dashboard-light"><label for="dashboard-bg-img-44" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-17-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-01" mode="dashboard-dark"><label for="dashboard-bg-img-01" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-01-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li class="dashboard-bg-more-button-wrap">
                            <button>${i18next.t(main.widget.more)}</button>
                        </li>
                    </ul>
                </dd>
            </dl>
            <dl class="dashboard-widget-pick-wrap">
                <dt>${i18next.t(dictionary.widget)}
                    <button class="js-widget-opinion widget-opinion"><i class="opinion-icon"></i>${i18next.t(common.sendFeedback)}</button>
                </dt>
                <dd><ul></ul></dd>
            </dl>
        </div>
    </article>

    <article class="popup-layer dashboard-set-popup dashboard-set-pick-wrap d-none">
        <header><h1><button class="icon-template-back"><i></i></button>${i18next.t(main.widget.gallery)}</h1>
            <button id="" class="btn-close">
                <i class="icons-close-1"></i>
            </button>
        </header>
        <div class="popup-main scroll-mask thin">
            <dl class="dashboard-bg-pick-wrap">
                <dt class="d-none">배경사진</dt>
                <dd>
                    <ul>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-01" mode="dashboard-dark"><label for="dashboard-bg-img-01" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-01-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-02" mode="dashboard-dark"><label for="dashboard-bg-img-02" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-02-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-03" mode="dashboard-dark"><label for="dashboard-bg-img-03" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-03-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-04" mode="dashboard-dark"><label for="dashboard-bg-img-04" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-04-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-05" mode="dashboard-dark"><label for="dashboard-bg-img-05" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-05-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-06" mode="dashboard-dark"><label for="dashboard-bg-img-06" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-06-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-07" mode="dashboard-dark"><label for="dashboard-bg-img-07" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-07-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-08" mode="dashboard-dark"><label for="dashboard-bg-img-08" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-08-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-09" mode="dashboard-dark"><label for="dashboard-bg-img-09" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-09-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-10" mode="dashboard-dark"><label for="dashboard-bg-img-10" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-10-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-11" mode="dashboard-dark"><label for="dashboard-bg-img-11" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-11-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-12" mode="dashboard-dark"><label for="dashboard-bg-img-12" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-12-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-13" mode="dashboard-dark"><label for="dashboard-bg-img-13" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-13-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-14" mode="dashboard-dark"><label for="dashboard-bg-img-14" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-14-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-15" mode="dashboard-dark"><label for="dashboard-bg-img-15" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-15-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-16" mode="dashboard-dark"><label for="dashboard-bg-img-16" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-16-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-17" mode="dashboard-dark"><label for="dashboard-bg-img-17" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-17-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-18" mode="dashboard-dark"><label for="dashboard-bg-img-18" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-18-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-19" mode="dashboard-dark"><label for="dashboard-bg-img-19" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-19-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-20" mode="dashboard-dark"><label for="dashboard-bg-img-20" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-20-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-21" mode="dashboard-dark"><label for="dashboard-bg-img-21" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-21-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-22" mode="dashboard-dark"><label for="dashboard-bg-img-22" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-22-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-23" mode="dashboard-dark"><label for="dashboard-bg-img-23" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-23-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-24" mode="dashboard-dark"><label for="dashboard-bg-img-24" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-24-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-25" mode="dashboard-dark"><label for="dashboard-bg-img-25" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-25-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-26" mode="dashboard-dark"><label for="dashboard-bg-img-26" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-26-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-27" mode="dashboard-dark"><label for="dashboard-bg-img-27" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/dark/mini/bg-dark-27-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>

                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-28" mode="dashboard-light"><label for="dashboard-bg-img-28" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-01-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-29" mode="dashboard-light"><label for="dashboard-bg-img-29" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-02-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-30" mode="dashboard-light"><label for="dashboard-bg-img-30" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-03-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-31" mode="dashboard-light"><label for="dashboard-bg-img-31" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-04-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-32" mode="dashboard-light"><label for="dashboard-bg-img-32" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-05-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-33" mode="dashboard-light"><label for="dashboard-bg-img-33" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-06-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-34" mode="dashboard-light"><label for="dashboard-bg-img-34" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-07-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-35" mode="dashboard-light"><label for="dashboard-bg-img-35" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-08-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-36" mode="dashboard-light"><label for="dashboard-bg-img-36" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-09-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-37" mode="dashboard-light"><label for="dashboard-bg-img-37" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-10-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-38" mode="dashboard-light"><label for="dashboard-bg-img-38" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-11-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-39" mode="dashboard-light"><label for="dashboard-bg-img-39" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-12-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-40" mode="dashboard-light"><label for="dashboard-bg-img-40" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-13-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-41" mode="dashboard-light"><label for="dashboard-bg-img-41" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-14-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-42" mode="dashboard-light"><label for="dashboard-bg-img-42" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-15-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-43" mode="dashboard-light"><label for="dashboard-bg-img-43" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-16-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-44" mode="dashboard-light"><label for="dashboard-bg-img-44" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-17-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-45" mode="dashboard-light"><label for="dashboard-bg-img-45" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-18-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-46" mode="dashboard-light"><label for="dashboard-bg-img-46" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-19-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-47" mode="dashboard-light"><label for="dashboard-bg-img-47" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-20-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-48" mode="dashboard-light"><label for="dashboard-bg-img-48" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-21-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-49" mode="dashboard-light"><label for="dashboard-bg-img-49" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-22-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-50" mode="dashboard-light"><label for="dashboard-bg-img-50" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-23-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                        <li>
                            <input type="radio" name="dashboard-bg-pick" id="dashboard-bg-img-51" mode="dashboard-light"><label for="dashboard-bg-img-51" style="background: url('/flow-renewal/assets/images/dashboard/bgImg/light/mini/bg-light-24-mini.jpg') no-repeat center / cover;"><span></span></label>
                        </li>
                    </ul>
                </dd>
            </dl>
        </div>
    </article>
    `
}

export {DashboardItem, SettingItem, getNoData, ttl2text, setProjectTtl, SettingPopupHtml}
